<div class=" m-0">   
    
    <app-bread-crumb 
        [Locations]="[{target : 'home', label : 'Home'}]"
        current="Contact Us">
    </app-bread-crumb>
        
    <app-hero-banner  title="Contact Us"></app-hero-banner>

    <div>
        <div>
            <app-feedback></app-feedback>
        </div>
    </div>

</div>